import React, { useState } from 'react';
import moment from 'moment';
import styled from 'styled-components/macro';
import { GridToolbar } from '@material-ui/data-grid';
import { FlexCenterHorizontal } from 'styles/flexbox';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { border } from 'variables/general';
import { brand } from 'variables/colors';
import { Card, CardHeavyShadow } from 'styles/card';
import { index10 } from 'variables/z-index';
import Button from 'components/ui/Button';
import { useSnackBar } from 'context/SnackBarContext';
import { createClinic, showClinic } from 'api/clinic';

const Component = styled(FlexCenterHorizontal)`
  padding-left: 0.5em;
`;

const Action = styled(FlexCenterHorizontal)`
  margin-left: 0.5em;
  color: ${brand};
  font-size: 0.875em;
  text-transform: uppercase;
  cursor: pointer;

  .MuiSvgIcon-root {
    margin-right: 0.4em;
    font-size: 16px;
  }
`;

const Copy = styled.div`
  position: relative;
`;

const AdditionalActions = styled.div`
  margin-top: 0.4em;
`;

const CopyMenu = styled(CardHeavyShadow)`
  position: absolute;
  bottom: -7.5em;
  z-index: ${index10};
`;

const AdditionalTableActions = ({ selectedRows, enableCopy, fetchClinics }) => {
  const [copyMenuOpen, setCopyMenuOpen] = useState(false);
  const { setMessage, setSeverity, setOpenSnackBar } = useSnackBar();

  const showActions = selectedRows.length === 1;

  const toggleCopyMenu = () => {
    setCopyMenuOpen(!copyMenuOpen);
  };

  const copyClinic = async () => {
    try {
      const { data } = await showClinic(selectedRows[0]);

      const {
        organization_id: organizationId,
        service_id: serviceId,
        schedule_id: schedulerId,
        sublocation_id: subLocationId,
        multi_days: multiDays,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        service_duration: serviceDuration,
        estimated_participants: estimatedParticipants,
        concurrent_slots: concurrentSlots,
        booking_cutoff_days_num: bookingCutOffDaysNum,
      } = data.data;

      const clinic = {
        organizationId,
        serviceId,
        schedulerId,
        subLocationId,
        multiDays,
        startDate,
        endDate,
        startTime: moment(startTime, 'hh:mm:ss').format('HH:mm'),
        endTime: moment(endTime, 'hh:mm:ss').format('HH:mm'),
        serviceDuration,
        estimatedParticipants,
        bookingCutOffDaysNum,
        concurrentSlots,
      };

      await createClinic(clinic);

      setMessage('Clinic Copied');
      setSeverity('success');
    } catch (error) {
      setMessage('Something went wrong. Failed to copy clinic.');
      setSeverity('error');
    }

    await fetchClinics();

    setOpenSnackBar(true);
    toggleCopyMenu();
  };

  return (
    <Component>
      <GridToolbar />

      {showActions && enableCopy && (
        <AdditionalActions>
          <Copy>
            <Action onClick={toggleCopyMenu}>
              <ContentCopyIcon />
              Copy
            </Action>

            {copyMenuOpen && (
              <ClickAwayListener onClickAway={toggleCopyMenu}>
                <CopyMenu>
                  <Button onClick={copyClinic}>Confirm Copy</Button>
                </CopyMenu>
              </ClickAwayListener>
            )}
          </Copy>
        </AdditionalActions>
      )}
    </Component>
  );
};

export default AdditionalTableActions;
